module.exports = __webpack_public_path__ + "img/pantalla-8-5.6cb961ac.png";